import { TuiNotificationService } from '@taiga-ui/core';
import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { notificationsActions } from './notifications.actions';
import { NotifyErrorPayload, NotifyPayload, NotifyStatusPayload } from './notifications.payload';

@Injectable()
export class NotificationsEffects {
  private readonly actions$ = inject(Actions);
  private readonly alertService = inject<TuiNotificationService>(TuiNotificationService);
  private readonly translocoService = inject(TranslocoService);

  success$ = createEffect(() =>
    this.actions$.pipe(
      ofType(notificationsActions.success),
      map(
        ({
          title = this.translocoService.translate('Les modifications ont été apportées.'),
          message,
        }: NotifyStatusPayload) =>
          notificationsActions.notify({
            title,
            message,
            status: 'positive',
          }),
      ),
    ),
  );

  error$ = createEffect(() =>
    this.actions$.pipe(
      ofType(notificationsActions.error),
      map(({ title, message }: NotifyErrorPayload) =>
        notificationsActions.notify({
          title,
          message,
          status: 'negative',
        }),
      ),
    ),
  );

  info$ = createEffect(() =>
    this.actions$.pipe(
      ofType(notificationsActions.info),
      map(({ title, message = this.translocoService.translate('Opération en cours') }: NotifyStatusPayload) =>
        notificationsActions.notify({
          title,
          message,
          status: 'info',
        }),
      ),
    ),
  );

  notify$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(notificationsActions.notify),
        map(({ title, message, status }: NotifyPayload) =>
          this.alertService
            .open(message, {
              label: title,
              appearance: status,
            })
            .subscribe(),
        ),
      ),
    { dispatch: false },
  );
}
